import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/providers/auth-provider";
import { getLeaderboard } from "@/services/leaderboard/get-leaderboard";
import { queryKeys } from "./query-keys";

export const useLeaderboard = () => {
  const { state } = useAuth();

  return useQuery({
    queryKey: queryKeys.leaderboard,
    queryFn: async () => {
      const response = await getLeaderboard();
      if (!response.ok) throw new Error(response.message);
      return response.data;
    },
    enabled: state.status === "authenticated",
  });
};
